module.exports = __webpack_public_path__ + "img/banner-hero.5cda8569.png";